import type { EntityEvent } from '@racemap/sdk/schema/entityEvents';
import { formatLabel } from '@racemap/utilities/formatting';
import { Typography } from 'antd';
import type { FC } from 'react';
import { useAlertStarter } from 'src/lib/customHooks/useAlertStarter';
import { getRelativeTime } from '../utils/timeUtils';

const { Text } = Typography;

interface Props {
  alert: EntityEvent;
  eventId: string;
}

export const NotificationText: FC<Props> = ({ alert, eventId }) => {
  const starter = useAlertStarter(alert, eventId);
  return (
    <Text style={{ color: '#fff' }}>
      Starter <u>{formatLabel([starter?.startNumber, starter?.name])}</u> received an alert{' '}
      <u>{getRelativeTime(alert.occurredAt)}</u> ago.
    </Text>
  );
};
